import { useEffect } from 'react';

import { useUserContext } from 'hooks/useUserContext';

type useCreateConfirmationPageHookApi = {
  trackCtaButtonClick: () => void;
};

function useCreateConfirmationPageHook(
  trackPageViewed: () => void,
  trackCtaClick: () => void
): useCreateConfirmationPageHookApi {
  const [userData] = useUserContext();

  const { publicId } = userData;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    trackPageViewed();
  }, [publicId, trackPageViewed]);

  const trackCtaButtonClick = () => {
    trackCtaClick();
  };

  return {
    trackCtaButtonClick,
  };
}

export default useCreateConfirmationPageHook;
